<div class="lb-local-seo-page-title-action">
  <ng-container *ngIf="service.seoSettings$ | async as settings">
    @if (isMobile) {
      <button
        [disabled]="!this.canEditKeywords"
        (click)="openSettings(settings)"
        mat-icon-button
        class="settings-button-mobile"
      >
        <mat-icon>settings</mat-icon>
      </button>
    } @else {
      <button [disabled]="!this.canEditKeywords" (click)="openSettings(settings)" mat-stroked-button>
        <mat-icon>settings</mat-icon>
        {{ 'COMMON.SETTINGS' | translate }}
      </button>
    }
  </ng-container>
  <div class="row row-gutters">
    <div class="col col-xs-12">
      <div class="date-range__container">
        <glxy-date-range-presets
          [defaultDatePeriod]="defaultDatePeriod"
          (selectedDateRange)="onDateRangeSelect($event)"
          [collapseViewportWidth]="'tablet-large'"
        ></glxy-date-range-presets>
      </div>
    </div>
  </div>
  <ng-container *ngIf="service.keywordStore$ | async as keywordStore">
    <ng-container *ngIf="service.keywordLimit$ | async as limit">
      <ng-container *ngIf="service.suggestedKeywords$ | async as suggestedKeywords">
        <button
          [disabled]="!this.canEditKeywords"
          (click)="openKeywords(keywordStore.keywords, limit, suggestedKeywords)"
          mat-flat-button
          color="primary"
        >
          <mat-icon style="margin-right: 0px; margin-left: 0px">add</mat-icon>
          @if (!isMobile()) {
            {{ 'LOCAL_SEO.ADD_KEYWORDS' | translate }}
          }
        </button>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
